import { useContext, useEffect, useState, type FC } from "react";
import { ExpandedContext } from "../contexts/Expanded";
import { LoadingContext } from "../contexts/LoadingContext";
import CustomSidebar from "./CustomSidebar";
import Loading from "./Loading";
import TopBar from "./TopBar";
import { getPermissions } from "../utils/storage";
interface MainLayoutProps {
  children: React.ReactNode;
  header?: React.ReactNode;
  noCard?: boolean;
}

const MainLayout: FC<MainLayoutProps> = ({ header, children, noCard }) => {
  const [activeKey, setActiveKey] = useState("1");
  const [openKeys, setOpenKeys] = useState(["3", "4"]);
  const { isExpanded, setIsExpanded } = useContext(ExpandedContext);
  const { isLoading, setIsLoading } = useContext(LoadingContext);

  useEffect(() => {
   
  }, []);

  return (
    <div className="main-layout">
      {isLoading && <Loading />}
      <div className="h-screen flex flex-col">
        <div className="flex-1 flex ">
          <div
            className="sidebar w-[250px] bg-white "
            style={{
              width: isExpanded ? "250px" : "60px",
            }}
          >
            <div className="flex flex-row p-4 logo justify-center items-center ">
              <img
                src="/images/logo-toko21.png"
                alt=""
                style={{
                  width: isExpanded ? "100px" : "40px",
                }}
              />
            </div>
            <CustomSidebar />
          </div>

          <div className="h-screen flex flex-col w-full  bg-[#f7f7fa]">
            <TopBar />
            <div className={`flex-1 px-8 py-4 flex-col  h-[calc(100%-7rem)]`}>
              <div className="mb-2">{header}</div>
              <div
                className={`flex-1  ${
                  header ? "h-[calc(100%-3rem)]" : "h-full"
                } ${!noCard && 'bg-white p-6 shadow-lg shadow-gray-200 rounded-lg'}  overflow-y-auto`}
              >
                <div className="">{children}</div>
              </div>
            </div>
            <div className="footer border-t p-2 text-gray-500 text-xs text-right">
              Copyright 2025 {process.env.REACT_APP_NAME}. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default MainLayout;
